<form [formGroup]="addressForm" class="fc-address-form" novalidate>
    <div class="fc-address-form-line-wrapper">
        <!-- Name -->
        <div class="fc-address-form-input-wrapper fc-address-form-input-wrapper-flex-2">
            <fcp-form-field [isInvalid]="hasToShowError('name')" width="fluid">
                <label fcpFieldLabel>
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.NAME' | translate }}
                </label>
                <input fcpInput formControlName="name" />
            </fcp-form-field>
        </div>

        <!-- Short Name -->
        <div class="fc-address-form-input-wrapper fc-address-form-input-wrapper-flex-1">
            <fcp-form-field [isInvalid]="hasToShowError('shortName')" width="fluid">
                <label fcpFieldLabel>
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.SHORT_NAME' | translate }}
                </label>
                <input fcpInput formControlName="shortName" />
                <span fcpFieldHint>
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.CHARACTERS_LIMIT' | translate }}
                </span>
                <span fcpFieldError *ngIf="addressForm.get('shortName').errors?.existingShortName">
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.VALIDATION.UNIQUE' | translate }}
                </span>
                <span fcpFieldError *ngIf="addressForm.get('shortName').errors?.maxlength">
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.VALIDATION.MAX_LENGTH' | translate }}
                </span>
            </fcp-form-field>
        </div>
    </div>
    <div class="fc-address-form-line-wrapper">
        <!-- Address (Street and Number) -->
        <div class="fc-address-form-input-wrapper">
            <fcp-form-field [isInvalid]="hasToShowError('address1')" width="fluid">
                <label fcpFieldLabel>
                    {{ 'ADDRESSLINE_1' | translate }}
                </label>
                <input fcpInput formControlName="address1" />
                <span fcpFieldError>
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.VALIDATION.ADDRESSLINE_1' | translate }}
                </span>
            </fcp-form-field>
        </div>

        <!-- City -->
        <div class="fc-address-form-input-wrapper">
            <fcp-form-field [isInvalid]="hasToShowError('city')" width="fluid">
                <label fcpFieldLabel>
                    {{ 'CITY' | translate }}
                </label>
                <input fcpInput formControlName="city" />
                <span fcpFieldError>
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.VALIDATION.CITY' | translate }}
                </span>
            </fcp-form-field>
        </div>

        <!-- Postal Code -->
        <div class="fc-address-form-input-wrapper">
            <fcp-form-field [isInvalid]="hasToShowError('zip')" width="fluid">
                <label fcpFieldLabel>
                    {{ 'POSTALCODE' | translate }}
                </label>
                <input fcpInput formControlName="zip" />
                <span fcpFieldError>
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.VALIDATION.POSTALCODE' | translate }}
                </span>
            </fcp-form-field>
        </div>
    </div>
    <div class="fc-address-form-line-wrapper">
        <!-- Phone Number -->
        <div class="fc-address-form-input-wrapper">
            <fcp-form-field [isInvalid]="hasToShowError('phone')" width="fluid">
                <label fcpFieldLabel>
                    {{ 'Phone Number' | translate }}
                </label>
                <input fcpInput formControlName="phone" />
                <span fcpFieldError>
                    {{ 'MANAGE_CLARA.CREATE_BRANCH.SHIPPING_ADDRESS.VALIDATION.PHONE_NUMBER' | translate }}
                </span>
            </fcp-form-field>
        </div>

        <!-- Country -->
        <div class="fc-address-form-input-wrapper">
            <fcp-form-field [isInvalid]="hasToShowError('country')" width="fluid">
                <label fcpFieldLabel>
                    {{ 'COUNTRY' | translate }}
                </label>
                <fcp-select
                    [items]="countryDropdownItems"
                    [getSelectedItemFunction]="getSelectedCountry"
                    [setSelectedItemFunction]="setSelectedCountry"
                    formControlName="country"
                ></fcp-select>
            </fcp-form-field>
        </div>

        <div class="fc-address-form-input-wrapper">
            <!-- Space placeholder -->
        </div>
    </div>
</form>
